import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RequestAddress, SaveAddress } from './@types';

const initialState = {
  city: [] as any[],
  district: [] as any[],
  ward: [] as any[],
  nation: [] as any[],
  profession: [] as any[],
  relative: [] as any[],
};

const resourceSlice = createSlice({
  name: 'resource',
  initialState,
  reducers: {
    requestNation: (_state, _action: PayloadAction) => undefined,
    saveNation: (state, action: PayloadAction<{ data: any }>) => {
      state.nation = action.payload.data;
    },
    requestRelative: (_state, _action: PayloadAction) => undefined,
    saveRelative: (state, action: PayloadAction<{ data: any }>) => {
      state.relative = action.payload.data;
    },
    requestProfession: (_state, _action: PayloadAction) => undefined,
    saveProfession: (state, action: PayloadAction<{ data: any }>) => {
      state.profession = action.payload.data;
    },
    requestAddress: (_state, _action: PayloadAction<RequestAddress>) => {},
    saveAddress: (state, action: PayloadAction<SaveAddress>) => {
      const { type, data } = action.payload;
      state[type] = data;
    },
  },
});

export const resourceActions = resourceSlice.actions;
export default resourceSlice;
